export default "__VITE_ASSET__CVFI247L__"